import React, { useState } from 'react';
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { uuidShortName } from '../../helpers';

function InfrastructureFilter (props) {
  //VEP-2142
  //const { filterSelectedType = '', filterselectedItem = '', onAllSelected, onRegionSelected, onUuidSelected } = props;
  const { filterSelectedType = '', filterselectedItem = '', onAllSelected, onUuidSelected } = props;
  const [dOpen, setDOpen] = useState(false);
  //VEp-2142
  //const [regionOpen, setRegionOpen] = useState(false);

  function byDeviceList () {
    return (
      <Collapse in={dOpen} timeout='auto'>
        <List disablePadding>
          {
            props.uuidList.map(item => (
              <ListItem
                button
                key={item}
                selected={filterSelectedType === 'By Device' && filterselectedItem === item}
                onClick={() => onUuidSelected(item)}
              >
                <ListItemText>{uuidShortName(item)}</ListItemText>
              </ListItem>              
            ))
          }
        </List>
      </Collapse>
    );
  }

  //VEP-2142
  /*function byRegionList () {
    return (
      <Collapse in={regionOpen} timeout='auto'>
        <List disablePadding>
          {
            props.regionList.map(item => (
              <ListItem
                button
                key={item}
                selected={filterSelectedType === 'By Region' && filterselectedItem === item}
                onClick={() => onRegionSelected(item)}
              >
                <ListItemText primary={item} />
              </ListItem>              
            ))
          }
        </List>
      </Collapse>
    );    
  }*/

  return (
    <div>
      <div className="muted margin-bottom-small">Filter</div>
      <List>
        <ListItem disableGutters
          style={{ paddingLeft: 4 }}
          classes={{ root: 'grouplist' }}
          button
          key='All'
          selected={filterSelectedType === 'All'}
          onClick={() => onAllSelected('All')}
        >
          <ListItemText primary='All' />
        </ListItem>
        <ListItem disableGutters
          style={{ paddingLeft: 4 }}
          classes={{ root: 'grouplist' }}
          button
          key='By Device'
          onClick={() => setDOpen(open => !open)}
        >
          <ListItemText primary='By Device' />
          {dOpen ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        {byDeviceList()}
        {
          //VEP-2142
          /*<ListItem disableGutters
            style={{ paddingLeft: 4 }}
            classes={{ root: 'grouplist' }}
            button
            key='By Region'
            onClick={() => setRegionOpen(open => !open)}
          >
            <ListItemText primary='By Region' />
            {regionOpen ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          {byRegionList()}*/
        }
      </List>
    </div>
  );
}

InfrastructureFilter.propTypes = {
  filterSelectedType: PropTypes.string.isRequired,
  filterselectedItem: PropTypes.string.isRequired,
  regionList: PropTypes.array.isRequired,
  uuidList: PropTypes.array.isRequired,
  onAllSelected: PropTypes.func.isRequired,
  onRegionSelected: PropTypes.func.isRequired,
  onUuidSelected: PropTypes.func.isRequired
};

export default React.memo(InfrastructureFilter);